const es = {
  nav: {
    home: "Inicio",
    about: "Sobre Nosotros",
    destinations: "Destinos",
    tours: "Tours y Paquetes",
    gallery: "Galería",
    testimonials: "Testimonios",
    blog: "Blog",
    contact: "Contáctenos",
    experiences: "Experiencias",
    vip: "VIP Negocios",
    vipFull: "Viajes VIP de Negocios",
    worldcup: "Copa del Mundo 2030",
    menu: "Menú",
    chatWhatsApp: "Chat en WhatsApp",
    jewishHeritage: "Viajes Kosher"
  },
  hero: {
    welcome: "Bienvenido a Marruecos.",
    welcomeHome: "Bienvenido a casa.",
    subtitle: "Tours privados de lujo, experiencias auténticas,",
    subtitleLine2: "y servicio personal completo en todo Marruecos —",
    subtitleGold: "gestionado personalmente por el CEO.",
    whatsappBtn: "Chatea con Ilan (CEO) ahora en WhatsApp",
    badgeFast: "Respuesta rápida",
    badgePersonal: "Servicio personal",
    badge247: "Disponibilidad 24/7",
    limitedAvail: "Disponibilidad limitada",
    personalizedOnly: "Solo viajes personalizados"
  },
  strip: {
    privateTours: "Tours Privados",
    localExperts: "Expertos Locales",
    bestHotels: "Mejores Hoteles",
    luxuryTransport: "Transporte de Lujo",
    satisfaction: "100% Satisfacción"
  },
  cta: {
    whatsapp: "Chatea con Ilan (CEO) ahora en WhatsApp",
    whatsappFloating: "Chat en WhatsApp",
    whatsappInquiry: "Hola, estoy interesado en una experiencia de viaje premium en Marruecos."
  },
  home: {
    vipBannerTitle: "Experiencias VIP en Marruecos",
    vipBannerText: "Acceso exclusivo, choferes privados y alojamientos de lujo para viajeros exigentes.",
    vipBannerBtn: "Descubrir Servicios VIP",
    wcBadge: "🇲🇦 Copa del Mundo Marruecos 2030",
    wcTitle: "Marruecos 2030",
    wcText: "Paquetes exclusivos para la Copa del Mundo que combinan fútbol, cultura marroquí, hospitalidad VIP y experiencias de lujo.",
    wcBtn: "Ver Paquetes",
    galleryTitle: "Galería",
    gallerySubtitle: "Un vistazo a tu futuro viaje marroquí",
    exploreDestination: "Explorar destino",
    featuredToursTitle: "Tours y Paquetes Destacados",
    featuredToursSubtitle: "Experiencias cuidadosamente seleccionadas para la aventura marroquí perfecta",
    viewAllTours: "Ver Todos los Tours",
    culinaryTitle: "Nuestra Comida - La Mejor del Mundo",
    culinarySubtitle: "Experimente la excelencia culinaria marroquí 🍲",
    culinaryBtn: "Descubrir Experiencias Culinarias",
    culinaryIntro: "En Morocco Loves You, comer no es solo alimentarse. Es un viaje al corazón de la cultura marroquí. Ofrecemos experiencias culinarias auténticas y seleccionadas — desde comidas caseras tradicionales hasta alta gastronomía marroquí, todo preparado con amor y los ingredientes locales más frescos.",
    videoTitle: "RECOMENDACIONES",
    unityQuote: "Morocco Loves You da la bienvenida a todas las culturas, todas las creencias y todos los pueblos.",
    unityAlt: "Morocco Loves You Banner de Unidad",
    testimonialsTitle: "Lo que Dicen Nuestros Invitados VIP",
    testimonialsSubtitle: "Reseñas reales de viajeros internacionales",
    readMoreReviews: "Leer Más Reseñas",
    viewAllTransport: "Ver Todo el Transporte",
    transportTitle: "Nuestro Transporte & Conductores VIP",
    transportSubtitle: "Lujo, Confort y Seguridad en todo Marruecos 🌍",
    transportIntro: "En Morocco Loves You, el transporte no es solo moverse de un lugar a otro. Es parte de la experiencia. Ofrecemos vehículos modernos, limpios, cómodos y con aire acondicionado en todo Marruecos — con conductores profesionales, hospitalidad cálida y servicio VIP desde el primer momento."
  },
  tours: {
    pageTitle: "Tours y Paquetes",
    pageSubtitle: "Elige entre nuestros paquetes de viaje cuidadosamente seleccionados",
    sectionTitle: "Nuestros Paquetes",
    sectionIntro: "Desde aventuras en el desierto hasta escapadas costeras, tenemos el paquete perfecto para cada viajero",
    howToBook: "Cómo Reservar",
    step1Title: "Elige un Tour",
    step1Text: "Explora nuestros paquetes y selecciona el que mejor te convenga",
    step2Title: "Haz Clic en Reservar",
    step2Text: "Haz clic en el botón \"Reservar\" del tour elegido",
    step3Title: "Completa los Datos",
    step3Text: "Proporciona tus fechas de viaje e información personal",
    step4Title: "Confirmación",
    step4Text: "Recibe confirmación y detalles del itinerario por correo electrónico",
    customTitle: "¿Necesitas un Paquete Personalizado?",
    customText: "Contáctanos para crear una experiencia marroquí a medida",
    customBtn: "Ponte en Contacto",
    days: "Días",
    highlights: "Destacados:",
    bookNow: "Reservar Ahora",
    highlightsLabel: "DESTACADOS:",
    viewFullDetails: "Ver Detalles Completos",
    viewDetails: "Ver Detalles",
    premiumPackage: "Paquete Premium",
    arrival: "Llegada:",
    route: "Ruta:",
    flights: "Vuelos:",
    transportation: "Transporte:",
    hotels: "Hoteles:",
    foodDining: "Comidas y Cenas:",
    whatsIncluded: "Qué Está Incluido:",
    attractionsExperiences: "Atracciones y Experiencias:",
    specialSaharaExperience: "Experiencia Especial en el Sahara:",
    suitableFor: "Adecuado Para:",
    importantNotes: "Notas Importantes:",
    priceInformation: "Información de Precios:",
    priceWarningText: "Los precios pueden cambiar según las tarifas de los vuelos, los tipos de cambio, los días festivos, las temporadas y la disponibilidad de los hoteles.",
    safetyComfort: "Seguridad y Confort:",
    safetyText: "Trabajamos en coordinación con las autoridades marroquíes y los servicios de seguridad para garantizar la seguridad y el confort de nuestros huéspedes.",
    safetyTextBrief: "Coordinado con las autoridades marroquíes para su seguridad.",
    givesMore: "Morocco Loves You da más:",
    givesMoreText: "Más amor, atención, profesionalidad, alegría y seguridad. Viajes fáciles y relajantes con auténtica hospitalidad humana.",
    givesMoreBrief: "Morocco Loves You:",
    givesMoreTextBrief: "Más amor, cuidado y profesionalidad.",
    bookThisPackage: "Reservar Este Paquete",
    backToPackages: "Volver a los Paquetes",
    premiumMoroccoPackages: "Paquetes Premium en Marruecos",
    premiumMoroccoPackagesDesc: "Experiencias exclusivas y cuidadosamente seleccionadas para nuestros huéspedes VIP.",
    suitable: {
      couples: "Parejas",
      families: "Familias",
      groups: "Grupos",
      solo: "Viajeros solos",
      seniors: "Personas mayores",
      companies: "Empresas",
      agencies: "Agencias de viajes",
      operators: "Operadores de tours"
    },
    pkg1: {
      title: "Escapada de Fin de Semana de Lujo en Fez",
      duration: "3 Noches / 4 Días (Jueves → Domingo)",
      price: "€790",
      hl1: "Vuelos directos de ida y vuelta incluidos (Londres/Europa)",
      hl2: "Hoteles de lujo de 4–5 estrellas",
      hl3: "Hammam tradicional marroquí",
      hl4: "Talleres de cocina y arte",
      hl5: "Espectáculos marroquíes en vivo",
      hl1_brief: "Vuelos directos de ida y vuelta incluidos",
      subtitle: "Paquete Todo Incluido – De la A a la Z",
      flight1: "Vuelos directos de ida y vuelta",
      flight2: "Equipaje facturado de 20 kg",
      flight3: "Equipaje de mano hasta 8 kg",
      inc1: "Recogida en el aeropuerto y traslado de vuelta",
      inc2: "Hoteles de 4–5 estrellas (Media pensión)",
      inc3: "Cocina marroquí fresca y auténtica",
      inc4: "Experiencia tradicional de té y pastas",
      inc5: "Guía turístico profesional y conductor privado",
      inc6: "Transporte moderno con aire acondicionado",
      inc7: "Espectáculos en vivo (Cantantes y bailarines)",
      inc7_brief: "Espectáculos especiales en vivo",
      inc8: "Tours por mercados tradicionales (Especias, Linternas, Alfombras)",
      inc8_brief: "Tours por mercados tradicionales",
      inc9: "Talleres de cocina y arte (Se requiere reserva previa)",
      inc9_brief: "Talleres de cocina y arte",
      inc10: "Visitas a fuentes naturales y miradores",
      inc11: "Excursiones de un día a Chauen e Ifrán",
      inc12: "Visitas a familias locales marroquíes",
      inc13: "Experiencias sorpresa durante el viaje",
      suit1: "Parejas",
      suit2: "Familias",
      suit3: "Grupos",
      suit4: "Viajeros solos",
      suit5: "Personas mayores",
      suit6: "Empresas",
      suit7: "Agencias de viajes",
      suit8: "Operadores de tours"
    },
    pkg2: {
      title: "Tour de Descubrimiento de Lujo en Marruecos",
      duration: "6 Noches / 7 Días (Lunes → Domingo)",
      price: "€1490",
      hl1: "Ruta de Fez y el Norte de Marruecos",
      hl2: "Visitas a Chauen y Tánger",
      hl3: "Vuelos directos y conductor privado",
      hl4: "Ubicaciones premium y servicio de alto nivel",
      hl5: "Auténtica hospitalidad marroquí",
      subtitle: "Ruta de Fez y Norte de Marruecos (Todo Incluido)",
      routeText: "2 noches en Fez, 1 noche en Chauen, 1 noche en Tánger, 1 noche en Ifrán, 1 noche final en Fez",
      flight1: "Vuelos directos de ida y vuelta desde Europa",
      flight2: "Equipaje de 20 kg + Equipaje de mano",
      trans1: "Recogida y traslado al aeropuerto",
      trans2: "Conductor privado profesional y guía turístico",
      trans3: "Nuevos vehículos con aire acondicionado",
      hotel1: "Hoteles de 4–5 estrellas",
      hotel2: "Ubicaciones premium",
      hotel3: "Servicio de alto nivel",
      food1: "Media pensión",
      food2: "Cocina auténtica",
      food3: "Té tradicional y pastas",
      exp1: "Espectáculos marroquíes en vivo",
      exp2: "Mercados tradicionales (Especias, Linternas, Alfombras)",
      exp3: "Hammam tradicional marroquí",
      exp4: "Visitas a la naturaleza y bosques",
      exp5: "Hermosos miradores y excursiones de un día",
      exp6: "Talleres de cocina y arte",
      exp7: "Visitas a familias locales",
      exp8: "Sorpresas especiales durante el viaje",
      suit1: "Parejas",
      suit2: "Familias",
      suit3: "Grupos",
      suit4: "Viajeros solos",
      suit5: "Personas mayores",
      suit6: "Empresas",
      suit7: "Agencias de viajes"
    },
    pkg3: {
      title: "Gran Experiencia de Marruecos",
      duration: "10 Noches / 11 Días (Viajeros Globales)",
      price: "€1990",
      hl1: "Servicios de tierra premium completos",
      hl2: "Casablanca, Marrakech y Fez",
      hl3: "Agadir y sorpresas en el desierto del Sahara",
      hl4: "Visita a Uarzazat y Chauen",
      hl5: "Música especial en vivo y espectáculos",
      subtitle: "✨ Gran Experiencia de Marruecos (Solo Servicios de Tierra)",
      arrivalText: "Casablanca o Marrakech",
      routeText: "Casablanca, Rabat, 2 noches en Fez, Tánger, Chauen, Ifrán, 2 noches en Marrakech, Agadir, Uarzazat, noche final en Marrakech",
      note2: "Grupos > 40: Descuento especial de $50 por persona",
      note3: "Vols internacionales y seguro NO incluidos",
      note4: "Propinas para conductor/guía NO incluidas",
      inc1: "Servicios de tierra premium completos",
      inc2: "Hoteles de 4–5 estrellas (Media pensión)",
      inc3: "Guía turístico profesional y conductor privado",
      inc4: "Autobús o minibús con aire acondicionado",
      inc5: "Espectáculos en vivo y ambiente musical",
      inc6: "Mercados tradicionales y visitas de Hammam",
      inc7: "Talleres de cocina y arte",
      inc8: "Excursiones a bosques, manantiales y miradores",
      inc9: "Visitas a familias locales",
      inc10: "Sorpresas especiales durante el viaje"
    },
    pkg4: {
      title: "Experiencia Imperial y del Sahara en Marruecos",
      duration: "13 Noches / 14 Días",
      price: "Todo Incluido",
      hl1: "2 Noches en el Desierto de Sahara en Merzouga",
      hl2: "Tendas premium con aire acondicionado y excursiones en Jeep",
      hl3: "Visita a las montañas del Atlas y al valle de Ourika",
      hl4: "Cascadas de Ouzoud y Ciudades Imperiales",
      hl5: "Servicios de tierra completos de la A a la Z",
      subtitle: "✨ Experiencia Imperial y del Sahara en Marruecos (Servicios de Tierra Completos)",
      routeText: "2 noches en Marrakech, valle de Ourika, Agadir, 2 noches en Merzouga, Uarzazat, cascadas de Ouzoud, Ifrán, Tánger, Chauen, 2 noches en Fez, El Yadida, Casablanca",
      sahara1: "Tendas de desierto premium con aire acondicionado",
      sahara2: "Ambiente musical junto a la fogata",
      sahara3: "Excursiones en Jeep y paseos en camello",
      sahara4: "Atardeceres y amaneceres inolvidables",
      inc1: "Servicios de tierra premium completos",
      inc2: "Hoteles de 4–5 estrellas (Media pensión)",
      inc3: "Guía turístico profesional y conductor privado",
      inc4: "Espectáculos especiales en vivo y bailarines",
      inc5: "Mercados tradicionales de especias, alfombras y linternas",
      inc6: "Hammam tradicional marroquí",
      inc7: "Talleres de cocina y arte"
    }
  },
  destinations: {
    pageTitle: "Explora los Destinos de Marruecos",
    pageSubtitle: "Descubre lugares increíbles para visitar en el hermoso Marruecos",
    sectionTitle: "Todos los Destinos",
    sectionIntro: "Marruecos es un país de paisajes diversos y rico patrimonio cultural. Explora nuestros destinos cuidadosamente seleccionados:",
    exploreNow: "Explorar Ahora",
    ctaTitle: "¿Listo para Planificar tu Viaje?",
    ctaText: "Explora nuestros tours y paquetes para encontrar la experiencia marroquí perfecta",
    ctaBtn: "Ver Tours y Paquetes"
  },
  experiences: {
    pageTitle: "Excelencia Culinaria Marroquí",
    pageSubtitle: "Descubre nuestra gastronomía — la mejor del mundo",
    bookViaWhatsApp: "Reservar por WhatsApp",
    introTitle: "Nuestra Experiencia Culinaria Única en Marruecos",
    introHighlight: "Sabores auténticos, ingredientes frescos, siglos de tradición y una hospitalidad inolvidable.",
    introP1: "Bienvenido a los sabores auténticos de Marruecos.",
    introP2: "En Morocco Loves You, la comida no es solo una comida — es cultura, historia, familia, hospitalidad y amor.",
    introP3: "Durante siglos, la cocina marroquí ha sido considerada una de las más ricas, saludables y sabrosas del mundo.",
    introP4: "Nuestras tradiciones culinarias combinan influencias árabes, bereberes, judías marroquíes, andaluzas, mediterráneas y africanas, creando recetas únicas conservadas durante más de 500 años.",
    prepTitle: "El Arte de la Preparación Marroquí",
    prepP1: "Todo se prepara con esmero, pasión, ingredientes frescos locales y auténticas especias marroquíes.",
    prepP2: "Seleccionamos cuidadosamente restaurantes de confianza, experiencias locales genuinas y destinos culinarios de calidad para nuestros huéspedes.",
    prepP3: "Marruecos es conocido mundialmente por sus mercados coloridos, agricultura fresca, productos naturales, especias, aceitunas, naranjas, repostería, té de menta y una hospitalidad inolvidable.",
    journeyVideos: "Videos de Viaje Culinario",
    highlightsTitle: "Destacados de la Cocina Tradicional",
    highlightTagine: "Tajín Marroquí Auténtico",
    highlightCouscous: "Cuscús Tradicional",
    highlightVegetables: "Verduras frescas e ingredientes naturales",
    highlightPastries: "Repostería y postres caseros",
    highlightBreakfasts: "Desayunos marroquíes tradicionales",
    highlightMeat: "Pescado fresco y carnes de calidad",
    highlightJuices: "Jugos naturales y té marroquí",
    highlightHealthy: "Tradiciones culinarias deliciosas y saludables",
    galleryTitle: "Nuestra Galería Culinaria",
    summaryP1: "Nuestro objetivo es ofrecer a nuestros huéspedes no solo un viaje, sino un verdadero viaje culinario marroquí.",
    tagHealthy: "Saludable",
    tagAuthentic: "Auténtico",
    tagTraditional: "Tradicional",
    tagFresh: "Fresco",
    tagUnique: "Único",
    tagDelicious: "Delicioso",
    important: "Importante:",
    guidanceNote: "Para obtener la mejor experiencia culinaria, recomendamos encarecidamente seguir la guía de nuestro equipo y las recomendaciones culinarias durante su viaje por Marruecos.",
    whereMeal: "Donde cada comida se convierte en un recuerdo.",
    whatsappLabel: "WhatsApp: +972 54-633-8757",
    moroccoLine: "Línea Marruecos: +212 6 63 63 05 79"
  },
  vip: {
    pageTitle: "Viaje VIP y de Negocios",
    pageSubtitle: "Servicios exclusivos para CEOs, inversores y viajeros exigentes",
    introTitle: "Excelencia Sin Igual en Marruecos",
    introText: "MoroccoLovesYou ofrece un estándar de servicio incomparable para viajeros de negocios, delegaciones corporativas e invitados VIP.",
    ctaTitle: "Acceso Directo al CEO",
    ctaText: "Para consultas urgentes, hable directamente con nuestro Fundador y CEO, Ilan Hatchuel.",
    ctaBtn: "Contactar a Ilan Ahora",
    luxuryTransport: "Transporte de Lujo",
    luxuryTransportDesc: "Traslados VIP al aeropuerto y choferes bilingues privados 24/7 con vehículos de lujo.",
    premiumAccom: "Alojamientos Premium",
    premiumAccomDesc: "Reservas exclusivas en hoteles 5 estrellas, riads de lujo o villas privadas.",
    businessConcierge: "Conserjería de Negocios",
    businessConciergeDesc: "Asistencia completa para reuniones, reservas de cenas privadas e itinerarios especializados.",
    securityPrivacy: "Seguridad y Privacidad",
    securityPrivacyDesc: "Servicio discreto, entornos seguros y confidencialidad absoluta.",
    support247: "Soporte 24/7",
    support247Desc: "Contacto directo con el CEO y un equipo dedicado listo para asistirle en todo momento.",
    customItineraries: "Itinerarios Personalizados",
    customItinerariesDesc: "Planes de viaje a medida que equilibran perfectamente sus obligaciones profesionales con experiencias culturales marroquíes."
  },
  worldcup: {
    pageTitle: "Copa del Mundo Marruecos 2030",
    pageSubtitle: "Paquetes VIP Exclusivos para el Mayor Evento Deportivo",
    limitedBadge: "Disponibilidad Limitada",
    introTitle: "El Viaje Futbolístico Definitivo",
    introText: "En 2030, Marruecos co-organizará la Copa del Mundo FIFA. MoroccoLovesYou se enorgullece de ofrecer paquetes de lujo todo incluido exclusivos.",
    packagesTitle: "Paquetes Premium Copa del Mundo",
    silverTitle: "Paquete Plata",
    silverSub: "La Experiencia Esencial",
    goldTitle: "Paquete Oro",
    goldSub: "La Experiencia de Lujo",
    mostPopular: "Más Popular",
    diamondTitle: "Diamante VIP",
    diamondSub: "La Experiencia Definitiva",
    inquireWhatsApp: "Consultar por WhatsApp",
    ctaTitle: "Asegura tu Lugar Antes de que Suban los Precios",
    ctaText: "Debido a la alta demanda internacional, recomendamos reservar su paquete VIP con anticipación.",
    ctaBtn: "Contáctenos Hoy",
    silverF1: "Riad Premium / Hotel 4 Estrellas",
    silverF2: "Logística Día de Partido Pre-planificada",
    silverF3: "Tours Guiados por Ciudades Sede",
    silverF4: "Línea de Soporte Dedicada 24/7",
    goldF1: "Hotel 5 Estrellas / Villa de Lujo",
    goldF2: "Traslados Privados Aeropuerto y Partidos",
    goldF3: "Escapada VIP Campo Desierto (2 Días)",
    goldF4: "Conserje Personal Bilingüe",
    diamondF1: "Suites Presidenciales / Palacios Privados",
    diamondF2: "Chofer Privado y Seguridad 24/7",
    diamondF3: "Acceso Exclusivo a Eventos VIP y Fiestas",
    diamondF4: "Gestión Directa CEO y Conserje VVIP"
  },
  gallery: {
    pageTitle: "Nuestra Galería",
    pageSubtitle: "Recuerdos visuales de viajes marroquíes inolvidables",
    picturesTitle: "Marruecos en Imágenes",
    picturesIntro: "Explora nuestra colección de fotos impresionantes de Marruecos",
    videosTitle: "Marruecos en Movimiento",
    videosIntro: "Experimenta Marruecos a través de nuestra colección de videos"
  },
  testimonials: {
    pageTitle: "Testimonios de Invitados",
    pageSubtitle: "Lee lo que nuestros viajeros dicen sobre su experiencia marroquí",
    sectionTitle: "Nuestros Viajeros Felices",
    sectionIntro: "Miles de huéspedes satisfechos han experimentado la magia de Marruecos con nosotros",
    verifiedGuest: "Huésped Verificado",
    ratingsTitle: "Nuestras Calificaciones",
    avgRating: "Calificación Promedio",
    verifiedReviews: "Reseñas Verificadas",
    fromReal: "De viajeros reales",
    custSatisfaction: "Satisfacción del Cliente",
    wouldRecommend: "Lo recomendarían",
    shareTitle: "Comparte tu Experiencia",
    shareText: "¿Tuviste un viaje increíble? ¡Nos encantaría saber de ti!",
    shareBtn: "Cuéntanos tu Historia"
  },
  blog: {
    pageTitle: "Blog de Viajes",
    pageSubtitle: "Historias, consejos y guías para tu aventura marroquí",
    sectionTitle: "Últimos Artículos de Viaje",
    sectionIntro: "Lee nuestros últimos artículos sobre viajar en Marruecos",
    readMore: "Leer Más →",
    by: "Por",
    newsletterTitle: "Suscríbete a Nuestro Boletín",
    newsletterText: "Recibe los últimos consejos de viaje y ofertas exclusivas",
    newsletterPlaceholder: "Ingresa tu correo electrónico",
    subscribe: "Suscribirse"
  },
  contact: {
    pageTitle: "Contáctenos",
    pageSubtitle: "Póngase en contacto con nuestro equipo para planificar su aventura VIP en Marruecos",
    getInTouch: "Ponte en Contacto",
    getInTouchText: "Estamos aquí para ayudarte y responder cualquier pregunta. Nuestro equipo está listo para asistirte.",
    address: "Dirección",
    phone: "Teléfono",
    email: "Correo Electrónico",
    businessHours: "Horario de Atención",
    followUs: "Síguenos",
    formTitle: "Envíanos un Mensaje",
    successMessage: "✓ ¡Gracias! Te responderemos pronto.",
    fullName: "Nombre Completo",
    emailAddress: "Correo Electrónico",
    phoneNumber: "Número de Teléfono",
    subject: "Asunto",
    selectSubject: "Selecciona un asunto",
    tourInquiry: "Consulta de Tour",
    bookingQuestion: "Pregunta de Reserva",
    customPackage: "Paquete Personalizado",
    feedback: "Comentarios",
    other: "Otro",
    message: "Mensaje",
    sendMessage: "Enviar Mensaje",
    mapTitle: "Encuéntranos en el Mapa",
    faqTitle: "Preguntas Frecuentes",
    faq1Q: "¿Cuál es la mejor época para visitar Marruecos?",
    faq1A: "La primavera (abril-mayo) y el otoño (septiembre-octubre) ofrecen el mejor clima.",
    faq2Q: "¿Necesito visa para visitar Marruecos?",
    faq2A: "Los requisitos de visa dependen de tu nacionalidad. Muchos países tienen entrada sin visa hasta 90 días.",
    faq3Q: "¿Qué moneda se usa en Marruecos?",
    faq3A: "El Dírham marroquí (MAD) es la moneda oficial. Los cajeros automáticos están ampliamente disponibles.",
    faq4Q: "¿Qué idioma se habla en Marruecos?",
    faq4A: "El árabe y el bereber (amazigh) son idiomas oficiales. El francés se habla ampliamente.",
    faq5Q: "¿Es Marruecos seguro para los turistas?",
    faq5A: "Sí, Marruecos es generalmente seguro para los turistas. Nuestros guías aseguran una experiencia segura.",
    faq6Q: "¿Puedo personalizar mi paquete de viaje?",
    faq6A: "¡Absolutamente! Ofrecemos paquetes personalizados adaptados a tus intereses, presupuesto y fechas."
  },
  about: {
    pageTitle: "Sobre MoroccoLovesYou",
    pageSubtitle: "Tu socio de confianza para descubrir la magia de Marruecos",
    storyTitle: "Nuestra Historia",
    storyP1: "MoroccoLovesYou fue fundada con una misión simple: ayudar a los viajeros a experimentar la auténtica belleza, cultura y hospitalidad de Marruecos.",
    storyP2: "Nuestra fundadora se enamoró de Marruecos y quiso compartir esta pasión con el mundo.",
    missionTitle: "🎯 Nuestra Misión",
    missionText: "Ofrecer experiencias de viaje excepcionales que muestren el rico patrimonio cultural de Marruecos.",
    visionTitle: "🌟 Nuestra Visión",
    visionText: "Ser la empresa turística líder de Marruecos reconocida por su autenticidad y fiabilidad.",
    whyTitle: "¿Por Qué Elegir MoroccoLovesYou?",
    expertTitle: "Conocimiento Experto",
    expertText: "Nuestro equipo tiene un amplio conocimiento de Marruecos.",
    localTitle: "Conexiones Locales",
    localText: "Trabajamos con guías y familias locales auténticas.",
    valueTitle: "Mejor Valor",
    valueText: "Precios competitivos sin comprometer la calidad.",
    safetyTitle: "Seguridad y Soporte",
    safetyText: "Soporte al cliente 24/7 y seguro de viaje incluido.",
    sustainTitle: "Turismo Sostenible",
    sustainText: "Apoyamos a las comunidades locales y practicamos turismo responsable.",
    bookingTitle: "Reserva Fácil",
    bookingText: "Proceso de reserva simple con opciones de pago flexibles.",
    teamTitle: "Nuestro Equipo",
    teamSubtitle: "Conoce a las personas apasionadas detrás de MoroccoLovesYou",
    happyTravelers: "Viajeros Felices",
    yearsExp: "Años de Experiencia",
    destinationsCount: "Destinos",
    satisfactionRate: "Tasa de Satisfacción"
  },
  footer: {
    description: "Descubre la magia de Marruecos con nosotros. Vive aventuras inolvidables y crea recuerdos duraderos.",
    quickLinks: "Enlaces Rápidos",
    more: "Más",
    contactInfo: "Info de Contacto",
    copyright: "© 2024 MoroccoLovesYou. Todos los derechos reservados."
  },
  starBanner: {
    ceoMessage: "MENSAJE DEL CEO",
    watchVideo: "Mira mi video",
    readMessage: "y lee mi mensaje",
    getToKnow: "Conoce a",
    ilanPersonally: "Ilan personalmente"
  },
  tourMini: {
    days: "10 DÍAS",
    nights: "/ 9 NOCHES",
    title: "TOUR PREMIUM\nMARRUECOS",
    years: "2026 - 2027",
    departures: "SALIDAS MENSUALES",
    allIncluded: "TODO INCLUIDO\nPENSIÓN COMPLETA",
    recommendations: "Recomendaciones",
    recCount: "500+ viajeros felices"
  },
  cityDetail: {
    notFound: "Ciudad no encontrada",
    backHome: "Volver al Inicio",
    discoverSubtitle: "Descubre la belleza y la cultura",
    planTrip: "Planificar mi viaje a",
    galleryOf: "Galería de",
    bookExperience: "Reservar esta Experiencia",
    requestItinerary: "Solicitar Itinerario Completo",
    readyToVisit: "¿Listo para Visitar",
    readyToVisitText: "Déjanos planificar tu viaje perfecto a este destino increíble",
    planMyTrip: "Planificar mi Viaje",
    talkExpert: "Hablar con un Experto"
  },
  transportation: {
    pageTitle: "Transporte VIP y Conductores",
    pageSubtitle: "Lujo, Confort y Seguridad en todo Marruecos",
    introTitle: "Nuestro Transporte & Conductores VIP",
    introP1: "En Morocco Loves You, el transporte no es solo moverse de un lugar a otro.",
    introP2: "Es parte de la experiencia.",
    introP3: "Ofrecemos vehículos modernos, limpios, cómodos y con aire acondicionado en todo Marruecos — con conductores profesionales, hospitalidad cálida y servicio VIP desde el primer momento.",
    introP4: "Ya sea que viaje en pareja, en familia, en una delegación de negocios o en un grupo privado, nos aseguramos de que su viaje sea seguro, relajante e inolvidable.",
    servicesTitle: "Nuestros servicios de transporte incluyen",
    servicesList: [
      "Autobuses VIP modernos",
      "Minibuses de lujo",
      "Coches privados",
      "Jeeps 4x4 para aventuras en el desierto",
      "Limusinas VIP",
      "Recogida y entrega en el aeropuerto",
      "Conductores profesionales multilingües",
      "Aire acondicionado confortable",
      "Vehículos limpios y organizados",
      "Refrigeradores en vehículos seleccionados",
      "Sistemas de TV y entretenimiento",
      "Música durante el viaje",
      "Conducción segura y suave",
      "Asistencia 24/7 en todo Marruecos"
    ],
    driversTitle: "Conozca a nuestros conductores",
    driversText1: "Nuestros conductores son parte de la familia Morocco Loves You.",
    driversText2: "Profesionales, respetuosos, experimentados y siempre listos para ayudar con una sonrisa.",
    driversText3: "Muchos de nuestros conductores hablan varios idiomas y conocen Marruecos profundamente, lo que ayuda a nuestros huéspedes a sentirse cómodos, seguros y conectados durante todo el viaje.",
    safetyTitle: "Seguridad y confort primero",
    safetyText1: "Su comodidad y seguridad son nuestras principales prioridades.",
    safetyText2: "Todos los vehículos reciben mantenimiento regular, se limpian y se preparan cuidadosamente antes de cada viaje.",
    safetyText3: "Trabajamos solo con conductores profesionales de confianza y socios de transporte de alta calidad.",
    categories: {
      buses: "Autobuses VIP",
      minibuses: "Minibuses de lujo",
      cars: "Coches privados y traslados VIP",
      jeeps: "Jeeps 4x4 y transporte en el desierto",
      meetDrivers: "Conozca a nuestros conductores",
      videos: "Videos de la experiencia de transporte"
    },
    videoGalleryTitle: "Videos de la experiencia VIP",
    ctaTitle: "¿Listo para explorar Marruecos con comodidad?",
    ctaSubtitle: "Hable directamente con Allan – CEO y fundador",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "Línea directa en Marruecos: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "Tours Casher de Lujo en Marruecos",
    pageSubtitle: "Patrimonio judío auténtico, cocina 100% casher, hospitalidad de lujo y experiencias únicas en Marruecos.",
    introTitle: "Experiencia de Lujo del Patrimonio Judío",
    introHeading: "Descubra el Marruecos Judío Auténtico",
    introText: "Descubra las raíces profundas de la historia judía en Marruecos con una experiencia de viaje elegante, auténtica y de primera calidad. Nos especializamos en brindar un viaje sin contratiempos para las comunidades judías de todo el mundo, centrándonos en el patrimonio, la conexión y el confort absoluto.",
    introQuote: "\"Marruecos es una tierra de tolerancia y coexistencia, donde el patrimonio judío se conserva con amor y respeto.\"",
    experiencesTitle: "Nuestras Experiencias Casher Incluyen",
    experiencesList: [
      "Comida y Restaurantes 100% Casher",
      "Chef Casher Privado Disponible",
      "Cocina Judía Marroquí Tradicional",
      "Hoteles de Lujo de 4 y 5 Estrellas",
      "Transporte Privado VIP",
      "Guías Profesionales Multilingues",
      "Tours de Patrimonio Judío y Sinagogas",
      "Cementerios y Museos Judíos",
      "Experiencias en el Desierto del Sahara y Hammam",
      "Asistencia Profesional 24/7"
    ],
    expFood: "Comida 100% Casher",
    expRestaurant: "Restaurante Casher",
    expChef: "Chef Casher Privado Disponible",
    expCuisine: "Cocina Judía Marroquí Tradicional",
    expHotels: "Hoteles de Lujo de 4 y 5 Estrellas",
    expDeluxeHotels: "Hoteles de gran categoría bajo petición",
    expTransport: "Transporte Privado VIP",
    expDrivers: "Conductores Profesionales",
    expAC: "Vehículos con Aire Acondicionado",
    expWifi: "WiFi, TV y neveras en vehículos seleccionados",
    expGuides: "Guías Profesionales Multilingues",
    expStaff: "Personal de habla hebrea / inglesa / francesa / española / rusa / alemana",
    expHeritage: "Tours de Patrimonio Judío",
    expSynagogues: "Sinagogas Antiguas",
    expCemeteries: "Cementerios Judíos",
    expMuseums: "Museos Judíos",
    expSpiritual: "Experiencias Espirituales y Culturales",
    expDesert: "Experiencias en el Desierto del Sahara",
    expHammam: "Experiencias de Hammam Marroquí",
    expAttractions: "Atracciones únicas en todo Marruecos",
    expAssistance: "Asistencia 24/7",
    packagesTitle: "Paquetes de Viajes Casher Flexibles",
    packagesIntro: "Personalizamos cada viaje de acuerdo con las necesidades, tradiciones, estilo de viaje, fechas y expectativas de nuestros huéspedes.",
    packageOptions: ["4–5 Días", "7–8 Días", "10–11 Días", "13–14 Días", "21 Días", "Tours Privados a Medida"],
    package4_5: "4–5 Días",
    package7_8: "7–8 Días",
    package10_11: "10–11 Días",
    package13_14: "13–14 Días",
    package21: "21 Días",
    packageTailor: "Tours Privados a Medida",
    packagesQuote: "“Personalizamos cada viaje de acuerdo con las necesidades, tradiciones, estilo de viaje, fechas y expectativas de nuestros huéspedes.”",
    safetyTitle: "Viaje Cómodo, Profesional y Seguro",
    safetyText: "Nuestros tours operan con gran atención al confort, la organización, la calidad del servicio y la coordinación profesional en todo Marruecos.",
    safetyQuote: "“Nuestros tours operan con gran atención al confort, la organización, la calidad del servicio y la coordinación profesional en todo Marruecos.”",
    b2bTitle: "Alianzas de Viajes Judíos B2B",
    b2bText: "Nos asociamos con comunidades judías, sinagogas, rabinos y operadores de tours casher de todo el mundo para crear viajes significativos sobre el patrimonio.",
    b2bPartnersList: "Trabajamos con: Comunidades judías, Sinagogas, Rabinos, Organizaciones judías, Operadores de tours casher y Agencias de viajes de todo el mundo.",
    partnerBtn: "Asóciese con Nosotros",
    galleryTitle: "Galería de Experiencia Casher",
    videosTitle: "Videos Destacados",
    ctaTitle: "¿Listo para comenzar su viaje?",
    msgAllan: "Enviar mensaje a Allan por WhatsApp",
    callMorocco: "Llamar a Marruecos: +212 6 63 63 05 79",
    ceoContact: "Hable directamente con Allan Hatchuel por WhatsApp",
    exploreBtn: "Explorar Tours Casher"
  },
  
  // Accessibility & UI Labels (Etiquetas de Accesibilidad e Interfaz)
  aria: {
    selectLanguage: "Seleccionar idioma",
    closeDetails: "Cerrar detalles",
    openMenu: "Abrir menú",
    closeMenu: "Cerrar menú",
    kosherTravel: "Viajes Casher en Marruecos",
    watchVideo: "Ver video de Marruecos Mágico",
    followInstagram: "Síguenos en Instagram",
    followFacebook: "Síguenos en Facebook",
    ceoMessage: "CEO de Morocco Loves You",
    whatsappSocial: "WhatsApp",
    instagramSocial: "Instagram",
    facebookSocial: "Facebook",
    jewishHeritageExperience: "Experiencia de patrimonio judío",
    kosherFoodMorocco: "Comida kosher en Marruecos",
    jewishHeritageMorocco: "Patrimonio judío en Marruecos",
    kosherExperience: "Experiencia kosher",
    luxuryHospitality: "Hospitalidad de lujo",
    kosherMoroccanTable: "Mesa marroquí kosher",
    jewishHeritageArchitecture: "Arquitectura del patrimonio judío",
    kosherOptionsAlt: "Opciones kosher",
    kingAlt: "Rey de Marruecos",
    logoAlt: "Logo MoroccoLovesYou"
  },
  
  // Form Placeholders (Marcadores de Posición del Formulario)
  forms: {
    firstName: "p.ej. Juan",
    lastName: "p.ej. García",
    email: "nombre@ejemplo.com",
    subject: "¿Cómo podemos ayudarte?",
    message: "Cuéntanos más sobre tus planes de viaje...",
    phone: "Tu número de teléfono",
    date: "Seleccionar una fecha",
    guests: "Número de huéspedes"
  },
  
  // Common UI Text (Texto Común de Interfaz)
  common: {
    selectLanguage: "Seleccionar idioma",
    instagram: "Instagram",
    facebook: "Facebook",
    loading: "Cargando...",
    error: "Ocurrió un error",
    success: "¡Éxito!",
    noResults: "No se encontraron resultados",
    viewMore: "Ver Más",
    viewLess: "Ver Menos",
    bookNow: "Reservar Ahora",
    learnMore: "Aprende Más",
    contactUs: "Contáctenos",
    close: "Cerrar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    search: "Buscar...",
    filter: "Filtrar",
    sort: "Ordenar",
    price: "Precio",
    duration: "Duración",
    languages: {
      english: "English",
      american: "American",
      australia: "Australia",
      canada: "Canada",
      french: "Français",
      spanish: "Español",
      hebrew: "עברית",
      arabic: "العربية",
      german: "Deutsch",
      italian: "Italiano",
      japanese: "日本語",
      chinese: "中文",
      korean: "한국어",
      vietnamese: "Tiếng Việt",
      russian: "Русский"
    }
  },
  
  // WhatsApp Message Templates (Plantillas de Mensajes WhatsApp)
  whatsapp: {
    greeting: "¡Hola Morocco Loves You! 🌟",
    bookPackage: "Me gustaría reservar el siguiente paquete:",
    packageInfo: "📦 Paquete: ",
    duration: "⏱️ Duración: ",
    price: "💰 Precio: ",
    bookingRequest: "Por favor, cuéntame la disponibilidad y los próximos pasos. ¡Gracias!",
    cityTrip: "Me gustaría planificar un viaje a {city}. ¿Puedes ayudarme?",
    silverPackage: "Estoy interesado en el Paquete Silver de la Copa del Mundo",
    goldPackage: "Estoy interesado en el Paquete Gold de la Copa del Mundo",
    diamondPackage: "Estoy interesado en el Paquete Diamond VIP de la Copa del Mundo",
    worldCupSecure: "Hola, quiero asegurar mi lugar para Morocco 2030.",
    kosherInquiry: "Estoy interesado en sus paquetes de viajes casher.",
    customPackage: "Me gustaría crear un paquete personalizado para nuestro grupo.",
    businessInquiry: "Estoy interesado en los servicios de viaje de negocios VIP."
  },
  
  // Blog Posts (Publicaciones del Blog)
  blog_posts: {
    post1: {
      title: "10 Gemas Ocultas para Descubrir en Marruecos",
      author: "Fatima Hassan",
      date: "15 de marzo de 2024",
      category: "Guía de Viajes",
      excerpt: "Descubre los destinos menos conocidos y los tesoros escondidos de Marruecos. De aldeas secretas en las montañas a áreas costeras vírgenes.",
      content: "Marruecos es mucho más que Marrakech y Casablanca. Esta guía integral revela gemas ocultas..."
    },
    post2: {
      title: "Mejor Época para Visitar Marruecos: Guía Completa",
      author: "Ahmed Bennani",
      date: "10 de marzo de 2024",
      category: "Planificación",
      excerpt: "¿Planificando tu viaje a Marruecos? Aprende sobre las mejores estaciones para visitar.",
      content: "Elegir el momento adecuado para visitar Marruecos puede impactar significativamente tu experiencia de viaje..."
    },
    post3: {
      title: "Gastronomía Marroquí: Una Aventura Culinaria",
      author: "Layla Rahim",
      date: "5 de marzo de 2024",
      category: "Comida y Cultura",
      excerpt: "Embarcate en un viaje culinario a través de Marruecos. Descubre los ricos sabores y recetas tradicionales.",
      content: "La gastronomía marroquí es una mezcla de influencias árabes, amaziges, andaluzas y africanas..."
    },
    post4: {
      title: "Cómo Regatear en los Mercados Marroquíes como un Profesional",
      author: "Youssef Alaoui",
      date: "28 de febrero de 2024",
      category: "Consejos de Viaje",
      excerpt: "Domina el arte del regateo en los souks y mercados marroquíes. Aprende las tácticas y consejos.",
      content: "El regateo en los mercados marroquíes no es solo una transacción; es un intercambio cultural..."
    },
    post5: {
      title: "Senderismo en los Montes Atlas: Lo que Necesitas Saber",
      author: "Ahmed Bennani",
      date: "20 de febrero de 2024",
      category: "Aventura",
      excerpt: "Explora las majestuosas Montañas del Atlas a pie. Obtén consejos de expertos sobre rutas y equipo.",
      content: "Las Montañas del Atlas ofrecen algunos de los paisajes más impresionantes del norte de África..."
    },
    post6: {
      title: "Safari del Desierto: Una Experiencia Inolvidable",
      author: "Fatima Hassan",
      date: "15 de febrero de 2024",
      category: "Aventura",
      excerpt: "Experimenta la magia del desierto del Sahara de Marruecos. Paseos en camello y noches bajo las estrellas.",
      content: "El desierto del Sahara representa el alma de Marruecos. Un safari por el desierto es más que una aventura..."
    },
    post7: {
      title: "Etiqueta Cultural: Respetando las Tradiciones Marroquíes",
      author: "Layla Rahim",
      date: "10 de febrero de 2024",
      category: "Cultura",
      excerpt: "Aprende las normas culturales esenciales para interactuar respetuosamente con el pueblo marroquí.",
      content: "Entender y respetar las costumbres locales es crucial al viajar a Marruecos..."
    },
    post8: {
      title: "Fotografía en Marruecos: Capturando la Magia",
      author: "Youssef Alaoui",
      date: "5 de febrero de 2024",
      category: "Fotografía",
      excerpt: "Descubre las ubicaciones más fotogénicas de Marruecos y consejos profesionales para capturar imágenes hermosas.",
      content: "Marruecos es un paraíso para fotógrafos. Desde las medinas azules hasta los desiertos dorados..."
    }
  },
  
  // Job Listings (Listados de Empleos)
  jobs: {
    title: "Carreras y Oportunidades",
    intro: "Únete al equipo de MoroccoLovesYou y construye tu futuro en viajes de lujo",
    workWith: "Trabaja con Amor, Cuidado y Excelencia",
    introText: "Buscamos individuos apasionados y dedicados que compartan nuestra visión de ofrecer experiencias de viaje de clase mundial.",
    openPositions: "Posiciones Abiertas",
    readyJoin: "¿Listo para Unirnos?",
    sendCV: "Envía tu CV a careers@moroccolovesyou.com",
    instructions: "Incluye una breve carta de presentación explicando por qué deseas unirte al equipo de Morocco Loves You.",
    
    job1: {
      title: "Guía Turístico Profesional Multilingüe",
      type: "Tiempo Completo / Estacional",
      location: "Marrakech / Fez / Marruecos",
      description: "Buscamos guías apasionados y conocedores que puedan llevar a la vida Marruecos para nuestros huéspedes VIP.",
      req1: "Fluido en al menos 2 idiomas (francés, español, inglés, hebreo, alemán, ruso o italiano preferido)",
      req2: "Conocimiento profundo de la historia, cultura y geografía marroquí",
      req3: "Habilidades profesionales, personables y excelente servicio al cliente",
      req4: "Aptitud física para trekking en el desierto y actividades al aire libre"
    },
    job2: {
      title: "Conductor Ejecutivo Lujo",
      type: "Tiempo Completo",
      location: "Marruecos",
      description: "Únete a nuestro equipo de transporte de lujo conduciendo vehículos Mercedes de alta gama.",
      req1: "Licencia de conducir válida con excelente historial de conducción (10+ años experiencia preferida)",
      req2: "Fluidez en inglés (idiomas adicionales, bonificación)",
      req3: "Apariencia profesional y comportamiento cortés",
      req4: "Conocimiento de las carreteras y rutas de Marruecos"
    },
    job3: {
      title: "Coordinador de Experiencia del Cliente",
      type: "Tiempo Completo",
      location: "Remoto / Híbrido (Oficina Fez)",
      description: "Apoya la oficina del CEO organizando itinerarios de lujo personalizados y gestionando comunicaciones con huéspedes.",
      req1: "Excelentes habilidades organizacionales y de comunicación",
      req2: "Experiencia en viajes, hotelería o servicio al cliente",
      req3: "Fluidez en inglés; idiomas adicionales bonificación",
      req4: "Competencia con sistemas de reserva y Microsoft Office"
    }
  },
  
  // Testimonials (Testimonios)
  testimonials_data: {
    intro: "Conoce a nuestros huéspedes satisfechos que han experimentado Marruecos con nuestros servicios",
    
    testi1: {
      name: "Sarah Johnson",
      title: "Londres, Reino Unido",
      rating: 5,
      text: "¡Morocco Loves You hizo mi viaje de ensueño una realidad! Cada detalle fue perfectamente organizado. El servicio es inigualable.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
    },
    testi2: {
      name: "Michael Chen",
      title: "Singapur",
      rating: 5,
      text: "Como viajero de negocios, quedé impresionado por la profesionalidad y personalización. Trato VIP desde el primer día.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi3: {
      name: "Emma Wilson",
      title: "Sídney, Australia",
      rating: 5,
      text: "¡La experiencia del desierto fue mágica! Dormir bajo las estrellas y la calidez de la hospitalidad marroquí superó todas mis expectativas.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
    },
    testi4: {
      name: "James Rodriguez",
      title: "Madrid, España",
      rating: 5,
      text: "Planificar un viaje familiar puede ser estresante, pero Morocco Loves You manejó todo brillantemente. ¡Seguro, educativo y divertido!",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
    },
    testi5: {
      name: "Anna Mueller",
      title: "Berlín, Alemania",
      rating: 5,
      text: "Aprecié la autenticidad cultural y el respeto mostrado a las tradiciones locales. No fue solo turismo; fue inmersión cultural genuina.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi6: {
      name: "David Thompson",
      title: "Toronto, Canadá",
      rating: 5,
      text: "La accesibilidad para personas mayores fue excepcional. Ritmo cómodo, guías solidarios y alojamientos de lujo.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
    },
    testi7: {
      name: "Lisa Anderson",
      title: "Nueva York, EE.UU.",
      rating: 5,
      text: "¡Amante de la comida aquí! Las experiencias culinarias fueron exquisitas. Cada comida contó una historia.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
    },
    testi8: {
      name: "Marcus Smith",
      title: "Los Ángeles, EE.UU.",
      rating: 5,
      text: "Lleno de aventura pero lujoso - exactamente lo que buscaba. Senderismo en el Atlas y safaris en el desierto con comodidad VIP.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi9: {
      name: "Sophie Laurent",
      title: "París, Francia",
      rating: 5,
      text: "¡Viaje romántico extraordinario! Atardecer en el Sahara, cenas privadas con vistas a Marrakech. Servicio atento en todo momento.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
    }
  },
  
  // Gallery Categories (Categorías de Galería)
  gallery_categories: {
    food: "Experiencia Culinaria",
    destinations: "Destinos",
    kosher: "Casher",
    transport: "Transporte VIP"
  },
  
  // Stats (Estadísticas)
  stats: {
    happyTravelers: "5000+",
    yearsExperience: "15+",
    destinationsCount: "25+",
    satisfactionRate: "98%"
  }
};

export default es;
